export default __webpack_public_path__ + "static/DSC_0049-908e75a559516a0c069b7d8e31d2f691.jpg";